const es = {
  meta: {
    home: {
      title: 'Manifestify | App de Manifestación y Afirmaciones',
      description:
        'Manifestify es una app de manifestación y afirmaciones diarias para iOS y Android. Crea tu manifiesto personal, fija intenciones, haz tableros de visión e interpreta tus sueños con IA.',
    },
    blog: {
      title: 'Blog de Manifestación: Afirmaciones, Guías y Métodos',
      description:
        'Guías expertas sobre cómo manifestar: afirmaciones diarias, el método 369, tableros de visión, scripting e interpretación de sueños. Nuevos artículos del equipo de Manifestify.',
    },
    notFound: {
      title: 'Página no encontrada | Manifestify',
      description: 'La página que buscas no existe.',
    },
    terms: {
      title: 'Términos y Condiciones | Manifestify',
      description: 'Los términos y condiciones de uso de la app y el sitio web de Manifestify.',
    },
    privacy: {
      title: 'Política de Privacidad | Manifestify',
      description: 'Cómo Manifestify recopila, usa y protege tus datos personales.',
    },
  },

  nav: {
    brandAria: 'Inicio de Manifestify',
    mainAria: 'Navegación principal',
    blog: 'Blog',
    getApp: 'Descargar la app',
    languageAria: 'Cambiar idioma',
    languageLabel: 'Idioma',
  },

  store: {
    downloadOn: 'Descárgala en',
    appStore: 'App Store',
    getItOn: 'DISPONIBLE EN',
    googlePlay: 'Google Play',
    appleAria: 'Descargar Manifestify en la App Store',
    googleAria: 'Conseguir Manifestify en Google Play',
  },

  home: {
    hero: {
      titleLine1: 'Manifiesta tus sueños, cada día.',
      titleAccent: '¡Con Manifestify!',
      subtitle:
        'La app de manifestación que mantiene viva tu práctica: afirmaciones diarias, un manifiesto personal, tableros de visión, intenciones e interpretación de sueños con IA, todo en un mismo lugar. Repite. Cree. Conviértete.',
      note: 'Descarga gratuita · iOS y Android',
    },
    features: {
      titlePre: 'Todo lo que necesitas para ',
      titleAccent: 'manifestar',
      titlePost: '',
      subtitle:
        'Una app para toda tu práctica, desde tu primera afirmación de la mañana hasta descifrar el sueño de anoche.',
      items: [
        {
          title: 'Afirmaciones diarias',
          text: 'Cientos de afirmaciones cuidadosamente elaboradas sobre amor, dinero, salud, confianza y paz interior, que te llegan cada día.',
        },
        {
          title: 'Manifiesto personal',
          text: 'Convierte tus metas en un manifiesto personal que lees y refuerzas a diario, para que tus sueños sigan delante de ti.',
        },
        {
          title: 'Fijar intenciones',
          text: 'Define intenciones diarias claras y deja que la app te mantenga anclado a lo que de verdad te importa.',
        },
        {
          title: 'Tablero de visión',
          text: 'Crea un tablero de visión digital de la vida que estás construyendo y visualízalo donde y cuando quieras.',
        },
        {
          title: 'Interpretación de sueños con IA',
          text: 'Describe tu sueño y descubre sus mensajes ocultos con interpretaciones profundas impulsadas por IA.',
        },
        {
          title: 'Cartas de energía',
          text: 'Saca una carta de energía cada día: un momento de reflexión y una dosis fresca de inspiración.',
        },
        {
          title: 'Recordatorios diarios',
          text: 'Notificaciones suaves a la hora que elijas, para que tu práctica no dependa de la memoria ni de la motivación.',
        },
        {
          title: 'Temas y fondos de pantalla',
          text: 'Temas y fondos preciosos que hacen que tu práctica se sienta personal e inspiradora.',
        },
      ],
    },
    how: {
      titlePre: 'Cómo ',
      titleAccent: 'funciona',
      titlePost: '',
      steps: [
        {
          title: 'Fija tu intención',
          text: 'Elige qué quieres manifestar y crea tu manifiesto personal a partir de cientos de afirmaciones seleccionadas.',
        },
        {
          title: 'Practica cada día',
          text: 'Repite tus afirmaciones, visualiza tu tablero y saca tu carta de energía. Los recordatorios mantienen viva tu racha.',
        },
        {
          title: 'Cree y conviértete',
          text: 'Observa cómo cambian tu enfoque, tu confianza y tus decisiones a medida que tu práctica se acumula día tras día.',
        },
      ],
    },
    blogTeaser: {
      titlePre: 'Aprende el arte de la ',
      titleAccent: 'manifestación',
      titlePost: '',
      subtitle:
        'Guías y técnicas del equipo de Manifestify, escritas para una práctica diaria real.',
      viewAll: 'Ver todos los artículos →',
    },
    faq: {
      titlePre: 'Preguntas ',
      titleAccent: 'frecuentes',
      titlePost: '',
      items: [
        {
          q: '¿Qué es Manifestify?',
          a: 'Manifestify es una app de manifestación y afirmaciones diarias para iOS y Android. Reúne toda tu práctica: afirmaciones en categorías como amor, carrera, abundancia y confianza, un manifiesto personal, fijación de intenciones, un tablero de visión, recordatorios diarios, cartas de energía e interpretación de sueños con IA.',
        },
        {
          q: '¿Manifestify es gratis?',
          a: 'Sí. Manifestify se descarga y se usa gratis tanto en la App Store como en Google Play. Los planes premium opcionales desbloquean la biblioteca completa de afirmaciones y funciones avanzadas como la interpretación de sueños con IA ilimitada.',
        },
        {
          q: '¿Qué es la manifestación?',
          a: 'La manifestación es la práctica de convertir tus metas en realidad mediante atención enfocada, creencia positiva y acción constante. Sus técnicas incluyen afirmaciones diarias, visualización, tableros de visión, scripting y el método 369.',
        },
        {
          q: '¿Cómo funcionan las afirmaciones diarias?',
          a: 'Las afirmaciones son frases positivas breves, en presente, que repites cada día. Con las semanas, remodelan tu diálogo interno y entrenan tu atención hacia oportunidades alineadas con tus metas. La constancia es la clave, y por eso Manifestify incluye recordatorios diarios.',
        },
        {
          q: '¿Manifestify está disponible en iPhone y Android?',
          a: 'Sí. Manifestify está disponible para iPhone y iPad en la App Store, y para dispositivos Android en Google Play.',
        },
        {
          q: '¿Cómo funciona la interpretación de sueños con IA?',
          a: 'Describes tu sueño en la app y Manifestify analiza sus símbolos, emociones y temas para darte una interpretación instantánea y profunda que puedes afinar con tu propio contexto.',
        },
      ],
    },
    download: {
      title: 'Empieza a manifestar hoy',
      text: 'Únete a quienes empiezan cada mañana con intención. Descarga Manifestify gratis y construye una práctica que perdure.',
    },
  },

  blog: {
    titlePre: 'El ',
    titleAccent: 'Blog',
    titlePost: ' de Manifestify',
    subtitle:
      'Guías prácticas sobre manifestación, afirmaciones, visualización e interpretación de sueños. Todo lo que necesitas para construir una práctica diaria que funcione.',
    schemaName: 'El Blog de Manifestify',
    schemaDescription:
      'Guías sobre manifestación, afirmaciones diarias, tableros de visión, scripting e interpretación de sueños.',
    readTime: '{n} min de lectura',
  },

  post: {
    breadcrumbAria: 'Ruta de navegación',
    home: 'Inicio',
    blog: 'Blog',
    ctaTitle: 'Ponlo en práctica con Manifestify',
    ctaText:
      'Afirmaciones diarias, un manifiesto personal, tableros de visión, intenciones e interpretación de sueños con IA. Toda tu práctica de manifestación en una app gratuita.',
    faqTitle: 'Preguntas frecuentes',
    relatedTitle: 'Sigue leyendo',
    relatedAria: 'Artículos relacionados',
  },

  notFound: {
    text: 'Esta página no existe, pero tus sueños sí.',
    backHome: 'Volver al inicio',
    readBlog: 'Leer el blog',
  },

  footer: {
    tagline:
      'Manifiesta tus sueños, cada día. Afirmaciones, intenciones, tableros de visión e interpretación de sueños en una sola app.',
    exploreTitle: 'Explorar',
    exploreAria: 'Explorar',
    home: 'Inicio',
    blog: 'Blog',
    downloadTitle: 'Descargar la app',
    downloadAria: 'Descargar',
    appStoreLink: 'iPhone y iPad (App Store)',
    playStoreLink: 'Android (Google Play)',
    legalTitle: 'Legal',
    legalAria: 'Legal',
    terms: 'Términos y Condiciones',
    privacy: 'Política de Privacidad',
    copyright: '© {year} Manifestify de Portal Studio. Todos los derechos reservados.',
  },

  legal: {
    back: 'Volver',
    translationNotice:
      'Esta es una traducción ofrecida por comodidad. La versión legalmente vinculante de este documento es la inglesa.',
    lastUpdated: 'Última actualización: {date}',
  },
};

export default es;
